import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=6ef1f2e8&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&lang=ts"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=6ef1f2e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1f2e8",
  null
  
)

export default component.exports